<template>
	<div class="caseDiv">
		<!-- banner -->
		<div class="banner">
			<img src="../../assets/img/banner22.jpg" alt="">
		</div>
		<!-- 成功案例 -->
		<div class="caseMain">
			<div class="homeTitle">
				<div class="homeTitleText">成功案例</div>
				<div class="homeTitleLine"></div>
			</div>
			<!-- 内容 -->
			<div class="caseMainCon">
				<div class="divss">
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片2.jpg" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：上海市建筑科学研究院(集团)有限公司</p>
							<p>应用功能：模型管理、资料管理、协同管理、桩基管理、分阶段管理、质量管理、安全管理、进度计划、视频监控、人员管理</p>
							<p>应用价值：平台协助各参建方之间的建设数据、信息和业务之间高效交互。自项目启动到建造过程中的各个施工节点，实现了结合BIM模型的双向应用，做到了虚实结合，大幅提升管理效率。
							</p>
						</div>
						<div class="caseMainConChildText">
							<p>张江科学之门项目</p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片3.png" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：上海市建筑科学研究院(集团)有限公司
							</p>

							<p>应用功能：模型管理、资料管理、协同管理、质量管理、安全管理、设计管理、进度计划、视频监控、车辆管理、人员管理、物料跟踪

							</p>
							<p>应用价值：通过BIM技术解决工地现场实际问题，减少现场签证和变更，进一步提高施工质量、控制施工进度和节约工程造价。结合施工阶段的BIM基础数据，为后续的运营维护提供切实可靠的运营维护平台。
							</p>

						</div>
						<div class="caseMainConChildText">
							<p>金融湾项目</p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片4.png" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：上海市建筑科学研究院(集团)有限公司
							</p>

							<p>应用功能：模型管理、资料管理、设计管理、图纸管理、工程管理、质量管理、安全管理、视频监控、桩基管理、会议管理、进度模拟
							</p>
							<p>应用价值：平台协助各参建方之间的建设数据、信息和业务之间高效交互。自项目启动到建造过程中的各个施工节点，实现了结合BIM模型的双向应用，做到了虚实结合，大幅提升管理效率。
							</p>

						</div>
						<div class="caseMainConChildText">
							<p>集成电路产业园</p>
						</div>
					</div>
				</div>
				<div class="divsss">
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片5.jpg" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：上海市建筑科学研究院(集团)有限公司
							</p>

							<p>应用功能：模型管理、资料管理、设计管理、工程管理、质量管理、安全管理、人员管理、进度管理
							</p>
							<p>应用价值：该项目是超高层商业酒店的综合体，平台应用以轻量化BIM模型为底层核心，同时结合项目施工过程的各业务条线管理，融入物联网监测数据。通过重点业务管控，实现计划管控、成本管理、现场施工协同和归档成果管控业务的综合应用。
							</p>

						</div>
						<div class="caseMainConChildText">
							<p>金桥17B-06地块商办项目</p>
						</div>
					</div>
					
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片7.jpg" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：上海市建筑科学研究院(集团)有限公司
							</p>
							<p>
								应用功能：资产管理、租赁管理、访客管理、成本管理、工单管理、运行管理、安防管理、能耗管理、应急管理、模型管理
							</p>
							<p>
								应用价值：GIS+BIM图形可视化、巡检维护派单流程可视化、应急指挥调度可视化和资产全生命可视化。
							</p>
						</div>
						<div class="caseMainConChildText">
							<p>综合管廊运维平台</p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/图片文件夹/图片6.png" alt="">
						</div>
						<div class="cnt">
							<p>合作单位：香港置地</p>
							<p>应用功能：生产订单、生产工序、运单、收货、安装、问题反馈，物料信息管理、仓库管理、HU管理、追溯看板、追溯地图、延期预警
							</p>
							<p>应用价值：项目运用场内、场外信息收集，多端协作，针对现场多品类物料的全生命周期追溯，运用各种统计分析手段，帮助客户提高工程建造效率和节约成本的目的。
							</p>
						</div>
						<div class="caseMainConChildText">
							<p>徐汇滨江项目</p>
						</div>
					</div>
				</div>
				<!-- <div class="divsss">
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_k4.jpg" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_s2.jpg" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_w1.png" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
				</div> -->
				<!-- <div class="divsss">
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_w2.png" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_w3.png" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
					<div class="caseMainConChild">
						<div class="caseMainConChildImg">
							<img src="../../assets/img/case/case_w4.png" alt="">
						</div>
						<div class="caseMainConChildText">
							<p></p>
						</div>
					</div>
				</div> -->
				<!-- 瀑布流开始 -->
				<!-- <div class="caseMainConChild" v-for="(item, index) in pbList" :key="index"
					:id="'caseMainConChild' + index" @click="popShow">
					<img :src="item.url" />
					<div class="caseMainConChildText">
						<h3>{{item.title}}</h3>
						<p>{{item.content}}</p>
					</div>
				</div> -->
				<!-- 瀑布流结束 -->
				<!-- <my-waterfall :data="pbList"></my-waterfall>
				<div style="clear: both;"></div> -->
				<!-- <waterfall :col="col" :data="pbList">
					<template>
						<div class="caseMainConChild" v-for="(item, index) in pbList" :key="index"
							:id="'caseMainConChild' + index" @click="popShow">
							<div class="itemBody">
								
								<img :lazy-src="item.url" />
								<div class="caseMainConChildText">
									<h3>{{item.title}}</h3>
									<p>{{item.content}}</p>
								</div>
							</div>
						</div>
					</template>
				</waterfall> -->
				<!-- for循环结束 -->
			</div>
			<!-- 分页 -->
			<!-- <div class="casePage">
			</div> -->
		</div>
	</div>
	<!-- 引入子组件 -->
	<!-- <Popver ref="popver" @refreshtreeTo="refreshtreeTo"></Popver> -->
	</div>
</template>
<script>
	// import Popver from '../../components/Popver.vue'
	export default {
		components: {
			// Popver,
		},
		data() {
			return {
				// 	col: 3, //设置显示几列
				// 	pbList: [
				// 		{
				// 			url: require("../../assets/img/case/case_j3.jpg"),
				// 			title: "金融湾",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_j4.jpg"),
				// 			title: "金融湾",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_j5.jpg"),
				// 			title: "金融湾",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_k1.jpg"),
				// 			title: "科创城",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_k2.jpg"),
				// 			title: "科创城",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_k3.jpg"),
				// 			title: "科创城",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_k4.jpg"),
				// 			title: "科创城",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_s2.jpg"),
				// 			title: "四期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_s2.jpg"),
				// 			title: "四期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_w1.png"),
				// 			title: "五期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_w2.png"),
				// 			title: "五期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_w3.png"),
				// 			title: "五期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 		{
				// 			url: require("../../assets/img/case/case_w4.png"),
				// 			title: "五期",
				// 			content: "建设方智慧工地系统",
				// 		},
				// 	],
			};
		},
		mounted() {
			// console.log(this.$route.query.pointIdName, "this.$route.query11")
			let pointIdName = this.$route.query.pointIdName
			if (pointIdName != undefined) {
				this.goRule(pointIdName)
			}
			// console.log(this.$waterfall,"this.$waterfall")
		},
		created() {
			document.documentElement.scrollTop = 0;
		},
		methods: {
			//锚点跳转
			goRule(event) {
				let id = "#" + event;
				console.log(document.querySelector(id), "document.querySelector(id)")
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "nearest",
				}, true);
				let that = this
				// this.$nextTick(() => {
				// 	that.$refs.popver.show()
				// })
			},
			// refreshtreeTo() { },
			// 显示弹窗
			// popShow() {
			// 	this.$refs.popver.show()
			// },
		},
	}
</script>
<style lang="scss" scoped>
	.caseDiv,
	.banner {
		width: 100%;
	}

	.caseDiv {
		background: rgb(255, 255, 255);
	}

	.banner {
		width: 100%;
		height: 450px;
		margin-bottom: 45px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	// 标题开始
	.homeTitle {
		width: 100%;
		text-align: center;
		margin: 0 auto;
		margin-bottom: 35px;

		.homeTitleText {
			height: 45px;
			font-size: 31px;
			color: #000;
			font-weight: 500;
			// padding: 60px 0 8px 0;
			padding: 30px 0 8px 0;
		}

		.homeTitleLine {
			width: 64px;
			height: 3px;
			background: #006fff;
			margin: 0 auto;
		}
	}

	// caseMain开始****************
	.caseMain {
		width: 65%;
		margin: 30px auto 0;
	}

	// caseMain结束****************
	// casePage开始****************
	.casePage {
		width: 100%;
		text-align: center;
		height: 20px;
		// background: red;
		// padding: 20px 0;
		padding: 8px 0;
		background: #f7f8fa;
	}

	// casePage结束****************
	// ****************修改样式
	.caseDiv /deep/ .el-carousel__container {
		height: 350px;
	}
</style>
<style scoped>
	/* 去掉列之间的margin */
	.vue-waterfall /deep/ .vue-waterfall-column {
		margin-left: 0px !important;
	}

	.caseMainCon {
		width: 100%;
		top: 0px;
		margin-bottom: 100px;
	}

	.divss {
		display: flex;
	}

	.divsss {
		display: flex;
		margin-top: 80px;
	}

	.caseMainConChild {
		width: 30%;
		height: 370px;
		margin: 0 20px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
		position: relative;
	}

	.cnt {
		width: 100%;
		height: 300px;
		position: absolute;
		top: 0;
		left: 0;
		/* bottom:10px; */
		background: rgba(0, 0, 0, .6);
		color: #fff;
		font-size: 18px;
		line-height: 1.5em;
		display: none;
		/* justify-content: center; 纵向居中关闭*/
		/* align-items: center;横向水平居中关闭  */
		flex-direction: column;
		overflow: hidden;
	}

	.cnt>p {
		top: 0px;
		margin-left: 20px;
		float: left;
		/* margin-top: 10px; */
		font-size: 15px;
		margin-right: 20px;
		margin-top: 10px;
	}

	.cnt>p:nth-child(1) {
		float: left;

	}

	.caseMainConChild:hover .cnt {
		display: flex;
	}

	.caseMainConChildText>p {
		text-align: center;
		line-height: 60px;
		font-size: 20px;
	}

	.caseMainConChildImg>img {
		width: 100%;
		height: 300px;
	}
</style>